import React from "react"
import propTypes from "prop-types"
import "./styles.scss"

const Stepper = ({ activeStep, steps, onGoAt, children }) => {
  return (
    <div className="stepper">
      <div className="stepper_nav">
        <ul>
          {steps.map(item => {
            if (item.children) {
              const active = item.children.find(step => {
                return step === activeStep
              })

              const complete =
                item.children[item.children.length - 1] < activeStep

              return (
                <li
                  key={item.id}
                  className={`stepper_item stepper_item--parent ${
                    item.step && item.step === activeStep
                      ? "stepper_item--active-no-children"
                      : ""
                  } ${active !== undefined ? "stepper_item--active" : ""} ${
                    complete ? "stepper_item--complete" : ""
                  }`}
                >
                  <div className="stepper_item_inner">
                    <button
                      type="button"
                      onClick={() => {
                        onGoAt(null, item.step ? item.step : item.children[0])
                      }}
                    />
                    <div className="stepper_item_label">
                      <span className="stepper_item_label--desktop">
                        {item.label}
                      </span>
                      <span className="stepper_item_label--mobile">
                        {item.labelMobile}
                      </span>
                    </div>
                  </div>

                  <ul>
                    {item.children &&
                      item.children.map(childIndex => {
                        const child = steps.find(step => {
                          return step.step === childIndex
                        })

                        return (
                          <li
                            key={child.id}
                            className={`stepper_item  stepper_item--child ${
                              child.step === activeStep
                                ? "stepper_item--active"
                                : ""
                            } ${
                              child.step < activeStep
                                ? "stepper_item--complete"
                                : ""
                            }`}
                          >
                            <button
                              type="button"
                              onClick={() => {
                                onGoAt(child.url, child.step)
                              }}
                            />
                            <div className="stepper_item_label">
                              {child.label}
                            </div>
                          </li>
                        )
                      })}
                  </ul>
                </li>
              )
            }
            return null
          })}
        </ul>
      </div>

      <div className="stepper_content">{children}</div>
    </div>
  )
}

Stepper.propTypes = {
  activeStep: propTypes.oneOfType([propTypes.string, propTypes.number])
    .isRequired,
  steps: propTypes.arrayOf(
    propTypes.shape({
      id: propTypes.oneOfType([propTypes.string, propTypes.number]),
      label: propTypes.string,
      url: propTypes.string,
      step: propTypes.oneOfType([propTypes.string, propTypes.number])
    })
  ).isRequired,
  onGoAt: propTypes.func.isRequired,
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired
}

export default Stepper
